import type { Officer } from '../types/domain'

export const officers: Officer[] = [
  { id: 'of-1', name: 'Hend AlMheiri', role: 'Director, Strategic Delivery Unit', initials: 'HA' },
  { id: 'of-2', name: 'Khalid Al Marzouqi', role: 'Head of Bid Assessment', initials: 'KM' },
  { id: 'of-3', name: 'Fatima Al Hosani', role: 'Senior Assessment Officer', initials: 'FH' },
  { id: 'of-4', name: 'Omar Bin Sulayem', role: 'Delivery Assurance Lead', initials: 'OS' },
  { id: 'of-5', name: 'Noura Al Kaabi', role: 'Outreach & Ecosystem Manager', initials: 'NK' }
]

export const currentOfficer = officers[0]
